// extracted by mini-css-extract-plugin
module.exports = {"layerInfo":"LayerInfo_layerInfo__tqv6c"};